export const WORKING_SESSION_LAYERS = [
  'Surface',
  'Harness',
  'Memory',
  'Evaluation',
  'Connectors',
] as const

export type WorkingSessionLayer = (typeof WORKING_SESSION_LAYERS)[number]

export const WORKING_SESSION_RULES =
  'We get the problem and what you want, then map five layers, then maybe name a possible first slice — not a promise. Talk or type. Captions on. Pause/repeat. Brief stays. No pitch. You leave with this table.'

export const WORKING_SESSION_VOICE_FAIL =
  "Voice didn't connect. Type here. Same session."

export function workingSessionStorageKey(token: string): string {
  return `yeshuman-working-session:${token}`
}
